import React from 'react';
import Message from './Message.jsx';

/**
 * Class to display the message that returns when the callback request
 * was a success and confirms the user's informaiton.
 */
export default class MindfulCallbackSucessMessage extends Message {
    constructor(props) {
        super(props);
    }

    /**
     * Takes the appojntmentTime value and coverts it to a readable date string.
     * If the value passed from appointmentTime creates an invalid date, then
     * return the initial value.
     *
     * This can occur either if the appointmentTime selected was ASAP, or
     * if the value passed would not create a valid date.
     */
    getTimeValue() {
        if (isNaN(this.props.payload.appointmentTime * 1000)) {
            return this.props.payload.appointmentTime;
        }
        const date = new Date(this.props.payload.appointmentTime * 1000);
        return `${date.toLocaleDateString('en-US')} at ${date.toLocaleTimeString('en-US', {hour: 'numeric', minute: '2-digit'})}`
    }

    render() {
        return(
            <div className={this.generateSenderClassName('mindful-callback-success')}>
                {this.generateSenderMessage()}
                <div className='message-text' dangerouslySetInnerHTML={this.evaluateMarkdown(this.props.payload.text.replace('{appointmentTime}', this.getTimeValue()))} />
            </div>
        );
    }
}